<template>
    <div v-if="form && model">
        <rkm-area no-margin-top title="Filtros" type="fieldset">
            <rkm-form
                ref="Form"
                show-legend
                >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="{ required: true }"
                            :end-validations="{ required: true }"
                            range
                            right
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <rkm-form-select
                            label="Motorista"
                            :options="form.motoristas"
                            v-model="model.motorista"
                            text-field="nome"
                            value-field="condutorId"
                            show-default-option
                            default-option-text="Todos"
                            @change="result = false"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            label="Status"
                            :options="form.status"
                            text-field="descricao"
                            value-field="id"
                            show-default-option
                            default-option-text="Todos"
                            v-model="model.status"
                            @change="result = false"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-button
                            :label="false"
                            @click="search"
                            color="primary"
                            >Buscar</rkm-button
                        >

                        <rkm-button :label="false" @click="reset"
                            >Limpar</rkm-button
                        >
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top title="Resultado"
            v-if="result"
        >
            <template v-slot:trailing>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <template>
                <div
                    v-for="(motorista, index) in motoristas"
                    class="mt-3"
                    :key="index"
                >

                    <template>
                        <div class="table-th text-center coleta">
                            Motorista: {{ motorista.nome }}
                        </div>
                    </template>

                    <rkm-table
                        :fields="fields"
                        :items="getViagens(motorista.id)"
                        no-footer-sorting
                        v-if="result"
                        sort-by="motorista"
                        hide-filters
                        hide-pagination
                    >

                        <template v-slot:custom-foot>
                            <tr>
                                <td class="table-td">
                                    Totais
                                </td>
                                <td
                                    v-for="(mes, index) in meses"
                                    :key="index"
                                    class="table-td text-center"
                                >
                                    {{ getTotalMes(motorista.id, mes.mes) }}
                                </td>
                                <td class="table-td text-center">{{ getTotalGeral(motorista.id) }}</td>
                            </tr>
                        </template>

                    </rkm-table>
                </div>
            </template>
        </rkm-area>

        <rkm-area
            title="Totais"
            no-margin-top
            v-if="result && (!this.model.motorista || this.model.motorista == 'Todos')"
        >
            <rkm-row>
                <rkm-col
                    v-for="mes in meses"
                    :key="mes.mes" class="upperCase">
                    {{ getStringMes(mes.mes) }}
                    <rkm-alert color="secondary">
                        <strong>
                            {{ mes.total }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col>
                    Total
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalMeses }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

    </div>
</template>

<script>
import { repository, error, data, object, stringCase, file } from "@/mixins";

import { mapActions } from "vuex";

import moment from "moment";

export default {
    watch: {
        "model.periodo.start": function () {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.model.motorista = null
                this.model.status = null
                this.getMotoristas();
            }
        },
        "model.periodo.end": function () {
            if (this.model.periodo.start && this.model.periodo.end) {
                this.model.motorista = null
                this.model.status = null
                this.getMotoristas();
            }
        },
    },
    computed: {
        optionalColumns() {
            return this.columns.filter((c) => !(c.fixed || false));
        },
        fields() {
            let meses = []
            if(this.meses.length > 0) {
                this.meses.forEach(item => {
                    if(item.mes == '1') {
                            meses = meses.concat({
                            key: "totalJaneiro",
                            label: "JAN",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '2') {
                            meses = meses.concat({
                            key: "totalFevereiro",
                            label: "FEV",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '3') {
                            meses = meses.concat({
                            key: "totalMarco",
                            label: "MAR",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '4') {
                            meses = meses.concat({
                            key: "totalAbril",
                            label: "ABR",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '5') {
                            meses = meses.concat({
                            key: "totalMaio",
                            label: "MAI",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '6') {
                            meses = meses.concat({
                            key: "totalJunho",
                            label: "JUN",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '7') {
                            meses = meses.concat({
                            key: "totalJulho",
                            label: "JUL",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '8') {
                            meses = meses.concat({
                            key: "totalAgosto",
                            label: "AGO",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '9') {
                            meses = meses.concat({
                            key: "totalSetembro",
                            label: "SET",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '10') {
                            meses = meses.concat({
                            key: "totalOutubro",
                            label: "OUT",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '11') {
                            meses = meses.concat({
                            key: "totalNovembro",
                            label: "NOV",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                    if(item.mes == '12') {
                            meses = meses.concat({
                            key: "totalDezembro",
                            label: "DEZ",
                            fixed: true,
                            class: "text-center"
                        })
                    }
                })
                meses = meses.concat({
                        key: "total",
                        label: "Total",
                        sortable: true,
                        fixed: true,
                        class: "text-center"
                    },)
            }
            return this.columns
                .concat(meses)
                .filter(
                    (c) => c.fixed || false || this.selectedCols.includes(c.key)
                );
        },
    },
    created() {
        this.repositories = {
            relatorioViagemMotorista: this.getConectaSusRepository(
                "transportePaciente.relatorioViagemMotorista"
            ),
            impressao: this.getConectaSusRepository(
                "impressao.transportePaciente"
            ),
            exportacao: this.getConectaSusRepository(
                "exportacao.transportePaciente"
            ),
        };
        this.load();
    },
    data() {
        return {
            model: null,
            form: null,
            columns: [
                {
                    key: "municipio",
                    label: "Município",
                    sortable: true,
                    fixed: true,
                    class: "col-6"
                },
                {
                    key: "protocolo",
                    label: "Protocolo",
                    fixed: true
                }
            ],
            items: [],
            motoristas: [],
            meses: [],
            totalMeses: null,
            selectedCols: [],
            result: false,
        };
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        handlePeriodo() {
            this.model.periodo.start = null
            this.model.periodo.end = null
        },
        quantidadeMes(item) {
            return item ? item.total : 0
        },
        getStringMes(mes) {
            moment.locale('pt-br');
            return moment.months(mes - 1);
        },
        load() {
            this.setLoading();
            this.repositories.relatorioViagemMotorista
                .index()
                .then(({ data }) => {
                    this.form = data.form;
                    this.model = data.model;
                    this.model.dataLimite = data.form.dataLimite
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        getMotoristas() {
            this.setLoading();
            this.repositories.relatorioViagemMotorista
                .getMotoristas({
                    data_inicial: moment(this.model.periodo.start).format(
                        "Y-M-D"
                    ),
                    data_final: moment(this.model.periodo.end).format("Y-M-D"),
                    status: this.model.status,
                })
                .then(({ data }) => {
                    this.form.motoristas = data;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        getViagens(motoristaId) {
            return this.items.filter(item => item.motoristaId == motoristaId)
        },
        getTotalMes(motoristaId, mes) {
            let totalMes = this.items.filter(item => item.motoristaId == motoristaId).reduce((sum, element) => {

                if (mes == '1') {
                    sum = sum + Number(element.totalJaneiro);
                } else if (mes == '2') {
                    sum = sum + Number(element.totalFevereiro);
                } else if (mes == '3') {
                    sum = sum + Number(element.totalMarco);
                } else if (mes == '4') {
                    sum = sum + Number(element.totalAbril);
                } else if (mes == '5') {
                    sum = sum + Number(element.totalMaio);
                } else if (mes == '6') {
                    sum = sum + Number(element.totalJunho);
                } else if (mes == '7') {
                    sum = sum + Number(element.totalJulho);
                } else if (mes == '8') {
                    sum = sum + Number(element.totalAgosto);
                } else if (mes == '9') {
                    sum = sum + Number(element.totalSetembro);
                } else if (mes == '10') {
                    sum = sum + Number(element.totalOutubro);
                } else if (mes == '11') {
                    sum = sum + Number(element.totalNovembro);
                } else if (mes == '12') {
                    sum = sum + Number(element.totalDezembro);
                }

                return sum;
            }, 0)

            return totalMes
        },
        getTotalGeral(motoristaId) {
            let totalTotal = this.items.filter(item => item.motoristaId == motoristaId).reduce((sum, element) => {

                sum = sum + Number(element.total);

                return sum;
            }, 0)

            return totalTotal
        },
        search() {
            this.$refs.Form.validate().then(valid => {
                if(valid) {
                    this.setLoading();
                    this.repositories.relatorioViagemMotorista
                        .list({
                            data_inicial: moment(this.model.periodo.start).format("Y-M-D"),
                            data_final: moment(this.model.periodo.end).format("Y-M-D"),
                            motorista: this.model.motorista,
                            status: this.model.status,
                        })
                        .then(({ data }) => {
                            this.result = true
                            this.items = data.consulta
                            this.motoristas = data.motorista
                            this.meses = data.meses
                            this.totalMeses = data.totalMeses
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading());
                }
            })
        },
        reset() {
            this.model.periodo.start = null
            this.model.periodo.end = null
            this.model.motorista = null
            this.model.status = null
            this.result = false
            this.items = [];
            this.motoristas = [];
        },
        print() {
            this.setLoading();
            this.repositories.impressao
                .relatorioViagemMotorista(this.prepareDataWithColumns())
                .then(({ data, headers }) =>
                    this.openFile(data, headers["content-type"])
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        exportTo() {
            this.setLoading();
            this.repositories.exportacao
                .relatorioViagemMotorista(this.prepareDataWithColumns())
                .then(({ data, headers }) =>
                    this.openFile(data, headers["content-type"])
                )
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        prepareDataWithColumns() {
            const data = this.prepareData();
            data.selectedCols = this.fields.map((f) => {
                return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class,
                };
            });
            return data;
        },
        prepareData() {
            const data = this.clone(this.model);
            data.dataInicial = moment(this.model.periodo.start).format("Y-M-D");
            data.dataFinal = moment(this.model.periodo.end).format("Y-M-D");
            data.motorista = this.model.motorista
            data.status = this.model.status
            data.filtroStatus = this.model.status
                ? this.form.status.find((s) => s.id == this.model.status).descricao
                : null;
            return this.camelObjectKeysToSnakeRecursive(data);
        },
    },
    mixins: [repository, error, data, object, stringCase, file],
};
</script>

<style scoped>
    .upperCase{
        text-transform: capitalize;
    }

    .table-th {
        background: #f1f1f1;
        height: 35px;
        line-height: 35px;
        font-weight: 600;
        border-top: 1px solid #dee2e6;
        border-left: 1px solid #dee2e6;
        border-right: 1px solid #dee2e6;
    }

    .coleta {
        background: #e9e9e9;
    }

    .table-td {
        background: #f1f1f1;
        padding: 0 10px;
        height: 35px;
        border-top: 1px solid #ccc;
        font-weight: 600;
    }

    .table-border-top {
        border-top: 0;
        height: 30px;
        padding: 0;
    }

    .table-width {
        width: 100%;
    }
</style>